import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-exibir-arquivos',
  templateUrl: './exibir-arquivos.component.html',
  styleUrls: ['./exibir-arquivos.component.scss']
})
export class ExibirArquivosComponent implements OnInit {

  contrato: any;


  constructor(
    public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
  }


  setUrlArquivo(urlArquivoContrato, tipoDeArquivo) {
    if (tipoDeArquivo == 'microsoft') {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`https://view.officeapps.live.com/op/view.aspx?src=${urlArquivoContrato}`);
    }

    if (tipoDeArquivo == 'pdf') {
      return this.sanitizer.bypassSecurityTrustResourceUrl(`${urlArquivoContrato}`);
    }

    if (tipoDeArquivo == 'image') {
      return `${urlArquivoContrato}`;
    }
  }

}
